/* src/app/forms/privacy/privacy.component.scss */
.block {
  animation: 0.5s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  padding: 5px;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}
.mktplace {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.mat-tab-body-content {
  height: auto !important;
}
.tabcontent {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.cardcontent {
  height: 25%;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
.transformimage {
  padding-top: 4px;
  transform: scale(1.5);
}
.transformimage2 {
  padding-top: 4px;
  transform: scale(2);
}
.transformimage3 {
  padding-top: 4px;
  transform: scale(3);
}
/*# sourceMappingURL=privacy.component.css.map */
